/* app/ui/equalise/equalise */

define(
	'app/ui/equalise/equalise',[
		'jquery',
		'util/mediaqueries',
		'evensteven'
	],
	function ($, MediaQueries) {

		var breakpoints = ['extra-large', 'large', 'medium', 'small', 'extra-small'],
			currentBp,
			equaliseGroups = [];

		// Cache EvenSteven objects in equaliseGroups array
		// This allows the update method to be called to change the columns option
		// Change columns on break points, stepping down from the current one until
		// a value is found as matches the grid CSS framework

		return {
			init: function () {
				MediaQueries.init();

				var equaliseGroup = function () {
					// Initialise equalisation for the group and cache its EvenSteven object
					var $group = $(this),
						cols = $group.data('equalise-cols') || 0;

					equaliseGroups.push($group.find('.js-equalise').evenSteven({
						resize: true,
						columns: cols
					}));
				};

				// Equalise all groups initially
				$('.js-equalise-group').each(equaliseGroup);

				// Initialise any groups added via AJAX
				$.subscribe('/ajax/replace/loaded', function (data) {
					// Asynchronous because of issues surrounding lazyloading images
					window.setTimeout(function () {
						data.html.find('.js-equalise-group').each(equaliseGroup).each(setBp(currentBp));
					}, 100);
				});

				// Update all groups' heights when text size changed
				$.subscribe('/text-size/change', function () {
					$.each(equaliseGroups, function () {
						this.update();
					});
				});

				// Get the number of columns for a group at a given breakpoint
				var getCols = function ($el, bp) {
					var i = breakpoints.indexOf(bp),
						cols;

					if (i !== -1) {
						for (; i < breakpoints.length; i++) {
							cols = cols || $el.data('equalise-cols-' + breakpoints[i]);
							if (cols) {
								break;
							}
						}
					}

					cols = cols || $el.data('equalise-cols');

					return cols;
				};

				// Update each group to match the current breakpoint
				var setBp = function (bp) {
					return function () {
						currentBp = bp;

						$.each(equaliseGroups, function () {
							var $group = $(this.element).closest('.js-equalise-group'),
								cols = getCols($group, bp);

							this.update({
								columns: cols
							});
						});
					};
				};

				MediaQueries.register([
					{
						queries: MediaQueries.queries['extra-large'],
						shouldDegrade: false,
						match: setBp('extra-large')
					},
					{
						queries: MediaQueries.queries.large,
						shouldDegrade: false,
						match: setBp('large')
					},
					{
						queries: MediaQueries.queries.medium,
						shouldDegrade: false,
						match: setBp('medium')
					},
					{
						queries: MediaQueries.queries.small,
						shouldDegrade: false,
						match: setBp('small')
					},
					{
						queries: MediaQueries.queries['extra-small'],
						shouldDegrade: false,
						match: setBp('extra-small')
					}
				]);
			}
		};

	}
);
